export default __webpack_public_path__ + "icon-social-media-instagram-rollover.51c0af95e6977f44becf.svg";